export const EVENT_NAME = {
    CHECKOUT_INITIATED: "TD_Flow"
};

export const EVENT_DATA = {
    CHECKOUT_INITIATED: {
        eventLabel: "Yes",
        eventAction: "TD_Flow",
        event: "checkout",
        eventCategory: "checkout_initiated"
    },
    EW_POPUP_OPEN: {
        event: "ew_pop_up_clicked",
        eventCategory: "ew_top_funnel"
    },
    CTA_OPTIMIZATION: {
        eventLabel: "Free_test_drive",
        eventAction: "cta_clicked",
        event: "custom_event",
        eventCategory: "CTA_optimisation"
    }
};
